import main from './phone';
export default main;